import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16c3402e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post-list" }
const _hoisted_2 = { class: "post-img" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "post-text" }
const _hoisted_5 = ["innerHTML"]



export default /*#__PURE__*/_defineComponent({
  __name: 'PostList',
  props: {
  posts: {
    type: [],
    default: 0,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.posts, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.hid
        }, [
          _createVNode(_component_router_link, {
            to: { name: 'post', params: { post: item.slug } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (item.image != '')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: item.image,
                      alt: item.name
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", null, _toDisplayString(item.name), 1),
                _createElementVNode("div", {
                  class: "desc",
                  innerHTML: item.description
                }, null, 8, _hoisted_5)
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ])
  ]))
}
}

})